import { HttpMethod, httpClient } from './http-client';

export interface PrintLabelResponse {
  label: string;
}

export interface SignedMessageResponse {
  signedMessage: string;
}

export const getPrintLabel = (entityType: string, entityId: number): Promise<PrintLabelResponse> => {
  return httpClient<PrintLabelResponse>(`/printLabel/${entityId}/entityType/${entityType}`, HttpMethod.Get);
};

export const getSignedMessage = (content: string): Promise<SignedMessageResponse> => {
  return httpClient<SignedMessageResponse>('/printLabel/signMessage', HttpMethod.Post, { content });
};
